import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsOtherNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M22.57 5.137a.5.5 0 01.813.006l8.723 12.359c1.411 1.999 4.386 1.97 5.758-.057l2.605-3.848A1.357 1.357 0 0141.593 13H46v-3h-4.407a4.357 4.357 0 00-3.608 1.915l-2.605 3.849a.5.5 0 01-.823.008L25.833 3.413c-1.381-1.957-4.276-1.979-5.687-.043L15.72 9.442c-.256.35-.663.558-1.097.558H2v3h12.624a4.357 4.357 0 003.521-1.79z" />
        <path d="M16.146 17.37c1.41-1.936 4.306-1.914 5.688.043l8.723 12.359a.5.5 0 00.823-.008l3.959-5.849A4.357 4.357 0 0138.947 22H46v3h-7.053c-.45 0-.872.224-1.124.597l-3.959 5.848c-1.372 2.027-4.346 2.056-5.758.057l-8.723-12.359a.5.5 0 00-.813-.006l-2.967 4.072A4.357 4.357 0 0112.08 25H2v-3h10.081c.434 0 .842-.207 1.097-.558z" />
        <path d="M16.383 31.143a.5.5 0 00-.813-.006l-4.425 6.072A4.357 4.357 0 017.624 39H2v-3h5.624c.433 0 .841-.207 1.097-.558l4.425-6.072c1.41-1.936 4.306-1.914 5.687.043l8.724 12.359a.5.5 0 00.823-.008l2.605-3.85A4.357 4.357 0 0134.593 36H46v3H34.593c-.45 0-.871.224-1.124.597l-2.605 3.848c-1.372 2.027-4.347 2.056-5.758.057z" />
      </g>
    </svg>
  )
);
SvgSportsOtherNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsOtherNormalLarge;
